var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBranding = function SvgBranding(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1.014 10C1.292 4.78 5.79.736 11.01 1.014c5.184.276 9.256 4.312 9.038 8.896-.154 2.896-2.658 5.145-5.554 4.99-.935-.05-2.26-.412-3.046.295-.608.546-.717 1.573-.157 2.194.818 1.029.087 2.682-1.292 2.609C4.78 19.72.736 15.22 1.014 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.007 9.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM9.777 5.763a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM14.252 9.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBranding);
export default ForwardRef;